var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49937 0C8.75002 0 8.14258 0.607444 8.14258 1.35679V4.07029H10.8561V1.35679C10.8561 0.607444 10.2486 0 9.49937 0Z",
    fill: "#01313D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4994 0C27.75 0 27.1426 0.607444 27.1426 1.35679V4.07029H29.8561V1.35679C29.8562 0.607444 29.2487 0 28.4994 0Z",
    fill: "#01313D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9286 4.07129H29.8571V9.49988C29.8571 10.2494 29.2495 10.8571 28.5 10.8571C27.7504 10.8571 27.1428 10.2494 27.1428 9.49988V4.07129H10.8571V9.49988C10.8571 10.2494 10.2495 10.8571 9.49994 10.8571C8.75038 10.8571 8.14277 10.2494 8.14277 9.49988V4.07129H4.07143C1.82284 4.07129 0 5.89413 0 8.14272V33.9284C0 36.177 1.82284 37.9999 4.07143 37.9999H33.9286C36.1772 37.9999 38 36.177 38 33.9284V8.14272C38 5.89413 36.1772 4.07129 33.9286 4.07129ZM35.2857 33.7584C35.2857 34.6019 34.678 35.2856 33.9285 35.2856H4.07143C3.32187 35.2856 2.71426 34.6019 2.71426 33.7584V13.9047H35.2857V33.7584Z",
    fill: "#01313D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 17.0996H2V36.0996H36V17.0996Z",
    fill: "#01313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.46c05576c62a94807a323aaf6076765a.svg";
export { ForwardRef as ReactComponent };